import axiosClient from "./axiosClient";

const BASE = "/admin/email";

const emailCampaignApi = {
    preview(audience: object) {
        return axiosClient.post(`${BASE}/preview`, { audience });
    },
    createCampaign(data: {
        name: string;
        subject: string;
        templateName?: string;
        htmlBody?: string;
        audience: object;
        createdBy?: string;
    }) {
        return axiosClient.post(`${BASE}/campaigns`, data);
    },
    sendCampaign(id: string) {
        return axiosClient.post(`${BASE}/campaigns/${id}/send`);
    },
    resumeCampaign(id: string) {
        return axiosClient.post(`${BASE}/campaigns/${id}/resume`);
    },
    listCampaigns(params?: { limit?: number; offset?: number; status?: string; q?: string }) {
        return axiosClient.get(`${BASE}/campaigns`, { params });
    },
    getCampaign(id: string) {
        return axiosClient.get(`${BASE}/campaigns/${id}`);
    },
    testSend(data: { toEmail: string; subject: string; htmlBody?: string; templateName?: string; templateData?: object }) {
        return axiosClient.post(`${BASE}/test-send`, data);
    },
    updateCampaign(id: string, data: { name?: string; subject?: string; htmlBody?: string; audience?: object }) {
        return axiosClient.put(`${BASE}/campaigns/${id}`, data);
    },
    getCampaignLogs(id: string, params?: { limit?: number; offset?: number; status?: string }) {
        return axiosClient.get(`${BASE}/campaigns/${id}/logs`, { params });
    },
    uploadImage(file: File) {
        const form = new FormData();
        form.append('image', file);
        return axiosClient.post(`${BASE}/upload-image`, form, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
    },
    deleteCampaign(id: string) {
        return axiosClient.delete(`${BASE}/campaigns/${id}`);
    },
};

export default emailCampaignApi;
